export function formatAndMaskMobile(mobileNumber: string) {
  if (!mobileNumber) return;

  const cleanedNumber = mobileNumber.replace(/\D/g, "");
  return "+91-" + "*".repeat(8) + cleanedNumber.slice(-2);
}

export const FULL_WIDTH_UTILITIES = [
  "success",
  "offer-calculator",
  "lead-created",
  "octopus-logs"
]